import { useContext, useEffect, useState } from "react";
import Title from "../Title/Title";
import { LangContext } from "../../../Context/LangContext";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./Aboutus.css";
import axios from "axios";
import { ABOUT, baseURL } from "../../../Api/Api";
export default function Aboutus() {
  const langCtx = useContext(LangContext);

const [disAbout , setDisAbout] = useState('')


  // get text about page 
  useEffect(() => {
    axios.get(`${baseURL}/${ABOUT}`, {
      headers: {
        "Accept": "application/json",
        "Accept-Language": `${langCtx}`,
      },
    })
    .then((res) => setDisAbout(res.data.data));
  }, [langCtx]);








  return (
    <section className="aboutus pg-section mr-section" id="aboutus">
      <div
        className="w-95"
        style={
          langCtx === "ar" ? { marginRight: "auto" } : { marginLeft: "auto" }
        }
      >
        <Row className="align-items-center">
          <Col lg={6}>
            <div className="text-aboutus">
              <Title name={text.titleAboutus[langCtx]} />
              <h3> {text.desAboutus[langCtx]}</h3>
              <p>
                {disAbout}
              </p>
            </div>
          </Col>
          <Col lg={6}>
            <div
              className="img-aboutus"
              style={
                langCtx === "ar"
                  ? { borderRadius: "0 64px 64px 0" }
                  : { borderRadius: " 64px 0 0 64px" }
              }
            >
              <div className="main-img-aboutus">
                <img src="/images/about1.png" alt="apps_about" />
                <img src="/images/about2.png" alt="apps_about" />
                <img src="/images/about.png" alt="apps_about" />
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
}

const text = {
  titleAboutus: {
    ar: "عن التطبيق",
    en: "About the application",
  },
  desAboutus: {
    ar: "تطبيق خاص بالمستخدمين و مزودي الخدمات",
    en: "An application for users and service providers",
  },
};
